import { configureStore } from "@reduxjs/toolkit";
import connectorReducer from "./connector-reducer";
import bulkUpdateReducer from "./bulkUpdate-reducer";
import leadReducer from "./lead-reducer";
import employeesReducer from "./employees-reducer";
import lendersReducer from "./lenders-reducer";
import insurerReducer from "./Insurer-reducer";
import permissionsReducer from "./permissions-reducer";
import notificationReducer from "./notification-reducer";
import notificationCountReducer from "./notificationCount-reducer";
import payoutReducer from "./payout-reducer";
import commonReducer from "./common-reducer";
import tenantReducer from "./tenant-reducer";
import bsaOutputReducer from "./bsaOutput-reducer";
import decisioningAuditReducer from "./decisioning-audit-reducer";
import bulkUploadReducer from "./bulkUpload-reducer";
import bulkLoginReducer from "./bulkLogin-reducer"
import bulkLoginUploadReducer from "./bulkLoginUpload-reducer"
import BulkLoginStartReducer from "./bulkLoginStart-reducer"
import reconciliationReducer from "./reconciliation-reducer"
import followUpReducer from "./followUp-reducer"
import aggregatorSlice from "./aggregator-reducer";

const store = configureStore({
  reducer: {
    common: commonReducer,
    tenant: tenantReducer,
    bsaOutput: bsaOutputReducer,
    connector: connectorReducer,
    bulkUpdate: bulkUpdateReducer,
    lead: leadReducer,
    bulkUpload: bulkUploadReducer,
    followUp : followUpReducer,
    employees: employeesReducer,
    lenders: lendersReducer,
    insurer: insurerReducer,
    permission: permissionsReducer,
    payoutReq: payoutReducer,
    notification: notificationReducer,
    notificationCount: notificationCountReducer,
    decisioningAudit: decisioningAuditReducer,
    bulkLoginLead:bulkLoginReducer,
    bulkLoginUpload:bulkLoginUploadReducer,
    BulkLoginStart:BulkLoginStartReducer,
    aggregator: aggregatorSlice,
    reconciliation: reconciliationReducer
  },
});

export default store;
export type RootState = ReturnType<typeof store.getState>;
